import { Loader2 } from "lucide-react";
import { useFormContext } from "@/lib/form/form-context";

interface SubmitButtonProps {
  label: string;
  loadingLabel?: string;
  disabled?: boolean;
  id?: string;
}

export function SubmitButton({
  label,
  loadingLabel = "Please wait…",
  disabled,
  id,
}: SubmitButtonProps) {
  const form = useFormContext();

  return (
    <form.Subscribe selector={(state) => state.isSubmitting}>
      {(isSubmitting) => (
        <button
          type="submit"
          id={id}
          disabled={disabled}
          aria-disabled={disabled || isSubmitting || undefined}
          aria-busy={isSubmitting || undefined}
          className={`
            relative flex h-11 w-full items-center justify-center gap-2 rounded-lg
            bg-indigo px-6 text-sm font-semibold text-white
            transition-all duration-200
            hover:bg-indigo-bright hover:shadow-lg hover:shadow-indigo/25
            active:scale-[0.98]
            aria-disabled:opacity-50 aria-disabled:cursor-not-allowed aria-disabled:hover:bg-indigo aria-disabled:hover:shadow-none aria-disabled:active:scale-100
          `}
        >
          {isSubmitting && <Loader2 size={16} className="animate-spin" />}
          {isSubmitting ? loadingLabel : label}
        </button>
      )}
    </form.Subscribe>
  );
}
